import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';
import { Button, Heading } from '@frontend/design-system';
import { useSettingsOverlay } from '../hooks/use-settings-overlay';

// TODO: Add tracking ids
export const SettingsPanelOverlayHeader = ({ children }: PropsWithChildren) => {
  const { hideOverlay } = useSettingsOverlay();

  return (
    <header
      css={{
        alignItems: 'center',
        borderBottom: `solid 1px ${theme.colors.neutral20}`,
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        padding: theme.spacing(2),
      }}
    >
      <Heading css={{ margin: 0 }} level={3}>
        {children}
      </Heading>
      <Button
        aria-label='close'
        onClick={hideOverlay}
        css={{ alignSelf: 'baseline' }}
        iconName='x-small'
        variant='secondary'
      />
    </header>
  );
};
